import * as Field from '@/components/ui/field'
import { Textarea } from '@/components/ui/textarea'
import { FieldInformation } from '@components'
import type { CreateSetup } from '@hvf/contracts'
import type { FormStore } from '@modular-forms/solid'
import { fieldInformation } from '../config/fieldInformation'
import type { FormFieldType } from '../index'

export function CustomTextarea(props: {
  name: keyof CreateSetup
  label: string
  form: FormStore<CreateSetup, undefined>
  FormField: FormFieldType
}) {
  return (
    <props.FormField name={props.name} type="string">
      {(field, formFieldProps) => (
        <Field.Root invalid={!!field.error}>
          <FieldInformation information={fieldInformation[props.name]}>
            <Field.Label>{props.label}</Field.Label>
          </FieldInformation>
          <Textarea {...formFieldProps} value={(field.value as string) ?? ''} />
          <Field.ErrorText>
            {field.error && <div>{field.error}</div>}
          </Field.ErrorText>
        </Field.Root>
      )}
    </props.FormField>
  )
}
